// The Details column of a listing whose rows each carry a params list — a
// workflow's steps, its subforms — as one line: how many fields, and which.
//
// Named by a listing config on the `params` property, not by any schema: an
// array property's widget override is honoured the way a oneOf's is not, so
// the edit form keeps the list widget it always had and only the listing cell
// changes. `Edit` delegates to that widget for the same reason param-details'
// does — a widget answers for every mode it is asked in.
import React from "react";
import * as ListWidget from "@repoflow/form-schema/widgets/list";

const SHOWN = 6;

export const View = ({ value }) => {
  const params = Array.isArray(value) ? value : [];

  if (params.length === 0) {
    return <span className="text-muted small">no fields yet</span>;
  }

  const names = params.map(({ label, name }) => label || name || "?");
  const shown = names.slice(0, SHOWN).join(", ");
  const more = names.length - SHOWN;

  return (
    <span className="text-muted small">
      {params.length} {params.length === 1 ? "field" : "fields"}: {shown}
      {more > 0 ? ` +${more} more` : null}
    </span>
  );
};

export const Edit = (props) => <ListWidget.Edit {...props} />;
